import { useInfiniteQuery } from '@tanstack/react-query';
import { useCallback } from 'react';

import { blogPostsInfiniteQueryOptions } from '#features/blog/model/blog';

export const useBlogPostsPagination = (tag?: string) => {
  const {
    data,
    isLoading,
    isError,
    isFetchNextPageError,
    refetch,
    fetchNextPage,
    hasNextPage,
    isFetching,
    isFetchingNextPage,
  } = useInfiniteQuery({
    // Same options object the /blog loader warms on the server, so the first render
    // already has the articles instead of fetching them again after hydration.
    ...blogPostsInfiniteQueryOptions(tag),
    select: (data) => {
      const allPosts = data?.pages?.flatMap((page) => page.records) ?? [];
      if (!tag) return allPosts;
      return allPosts.filter((post) =>
        post.tags?.split(',').some((t) => t.trim().toLowerCase() === tag.toLowerCase())
      );
    },
  });

  const loadMore = useCallback(() => {
    if (hasNextPage && !isFetching) {
      fetchNextPage();
    }
  }, [fetchNextPage, hasNextPage, isFetching]);

  return {
    items: data ?? [],
    isLoading,
    isError,
    isFetchNextPageError,
    refetch,
    hasNextPage,
    isFetchingNextPage,
    loadMore,
  };
};
